/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { startHealthLog } from './app/debug/health-log';

bootstrapApplication(AppComponent, appConfig)
    .then(startHealthLog) // [health] temporary soak-test diagnostics
    // eslint-disable-next-line no-console
    .catch((err) => console.error(err));
